export default __webpack_public_path__ + "static/media/menu3.138b6219.png";